import { exec } from "jadelet"
export default exec(["about",{},[{"bind":"hotkeysInfoElement"}]])